module.exports = __webpack_public_path__ + "media/images/turbochargers/KKK_old-3d25e622ef33624f0c9f5b3174d52a67.jpg";